import {
	BitrateControl, Codec, ImageQuality, Profile, VideoFormat, AntiFlickerMode, BacklightCompensation,
	DayNightMode, DefogControl, DigitalNoiseReduction, DwellTime, EnhancementActivation, ExposureMode,
	HighlightCompensation, IlluminationMode, IrLed, ManualWbMode, MaxAgc, MirrorImage, PIrisControl, ShutterSpeed,
	SlowShutter, WhiteBalanceMode, WhiteLedControl, FirstStreamResolution, SecondStreamResolution,
	ThirdStreamResolution, FourthStreamResolution
} from "Data/Objects/Camera";
import type { CodecSettingsState, ImageSettingsState } from "Interfaces";

export const DUMMY_CODEC_SETTINGS: CodecSettingsState = {
	streams: [
		{
			codec: Codec.H264,
			profile: Profile.BASELINE,
			resolution: FirstStreamResolution.R2592X1944,
			frameRate: 30,
			gopSize: 1,
			bitrateControl: BitrateControl.CBR,
			bitrate: 512,
			imageQuality: ImageQuality.LOW,
			mjpegQuality: 0
		},
		{
			codec: Codec.H264,
			profile: Profile.MAIN,
			resolution: SecondStreamResolution.R1280X720,
			frameRate: 2,
			gopSize: 1,
			bitrateControl: BitrateControl.CBR,
			bitrate: 512,
			imageQuality: ImageQuality.LOW,
			mjpegQuality: 0
		},
		{
			codec: Codec.H264,
			profile: Profile.MAIN,
			resolution: ThirdStreamResolution.R640X360,
			frameRate: 2,
			gopSize: 1,
			bitrateControl: BitrateControl.CBR,
			bitrate: 512,
			imageQuality: ImageQuality.LOW,
			mjpegQuality: 0
		},
		{
			useStreamSettings: "mainStream",
			frameRateLabel: 0.5,
			frameRate: 15,
			resolution: FourthStreamResolution.R1920X1080
		}
	],
	videoFormat: VideoFormat.NTSC
};

export const DUMMY_IMAGE_SETTINGS: ImageSettingsState = {
	appearance: {
		mirrorImage: MirrorImage.HORIZONTAL_VERTICAL,
		brightness: 15,
		contrast: 15,
		color: 15,
		sharpness: 8,
		whiteBalanceMode: WhiteBalanceMode.AUTO,
		manualWbMode: ManualWbMode.INDOOR
	},
	exposure: {
		exposureMode: ExposureMode.AUTO,
		agcGain: 0,
		eShutterSpeed: 30,
		maxAgc: MaxAgc.HIGH,
		baseShutterSpeed: ShutterSpeed.S_30,
		maxShutterSpeed: ShutterSpeed.S_30,
		slowShutter: SlowShutter.OFF,
		antiFlickerMode: AntiFlickerMode.OFF,
		pIrisControl: PIrisControl.AUTO
	},
	enhancement: {
		wideDynamicRange: true,
		backlightCompensation: BacklightCompensation.OFF,
		highlightCompensation: HighlightCompensation.OFF,
		digitalNoiseReduction: DigitalNoiseReduction.OFF,
		defogControl: DefogControl.OFF,
		enhancementActivation: EnhancementActivation.DAY
	},
	dayNight: {
		dayNightMode: DayNightMode.AUTO,
		dwellTime: DwellTime.D0,
		dayTimeStart: 0,
		dayTimeEnd: 0,
		dayToNightSensitivity: 0,
		nightToDaySensitivity: 3,
		illuminationMode: IlluminationMode.IR,
		irLed: IrLed.AUTO,
		adaptiveIr: false,
		irLedIllumination: 255,
		antiOverexposure: true,
		whiteLedControl: WhiteLedControl.AUTO,
		whiteLedIllumination: 255
	},
	zoomFocus: {
		zoomFocusArea: [
			{ x: 760, y: 340 },
			{ x: 1160, y: 340 },
			{ x: 1160, y: 740 },
			{ x: 760, y: 740 }
		],
		zoom: 40,
		focus: 658,
		iris: "Auto Mode",
		dayNightFocusShift: false
	}
};
